import { config } from './config'

/** The API answers JSON, but an auth redirect or a gateway error answers HTML. */
export async function errorMessageFrom(response: Response): Promise<string | undefined> {
  try {
    return (await response.json()).error
  } catch {
    return undefined
  }
}

/**
 * `credentials: 'include'` on every request: the WorkOS cookie is `__Host-`/`SameSite=None`, and
 * without it the 302 to `/` comes back as index.html with a 200.
 */
export async function callApi<T>(path: string, init: RequestInit, whenItFails: string): Promise<T> {
  const response = await fetch(`${config.apiBaseUrl}${path}`, { credentials: 'include', ...init })

  if (!response.ok) {
    throw new Error((await errorMessageFrom(response)) ?? whenItFails)
  }

  return response.json()
}
